import React from 'react';

import { SvgIcon, SvgIconProps } from '@mui/material';

import { ReactComponent as Icon } from './MinusIcon.svg';

/**
 * @function
 * Auto-generated file.
 */
export const MinusIcon = React.forwardRef<SVGSVGElement, SvgIconProps>(function MinusIcon(props, ref) {
  return (
    <SvgIcon ref={ref} viewBox="0 0 14 2" component={Icon} {...props} />
  );
});
